<template>
  <el-dialog title="新建/编辑" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
      <div class="reimbursement">
        <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="form.roleName" />
          </el-form-item>
          <el-form-item label="角色编码" prop="code">
            <el-input v-model="form.code" />
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" />
          </el-form-item>
          <el-form-item label="角色状态" prop="c">
            <el-radio-group v-model="form.roleStatus">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="菜单">
            <!-- <el-select v-model="form.sysMenuList" style="width:100%;" placeholder="请选择" filterable clearable multiple>
          <el-option v-for="item in options.sysMenu" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select> -->
            <el-tree :data="treeData" show-checkbox node-key="id" :default-expanded-keys="expandedList" @check="check" :default-checked-keys="checkedList" :props="defaultProps">
            </el-tree>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysRoleApi from '@/api/system/sysRole'
import sysMenuApi from '@/api/system/sysMenu'
import enums from '@/utils/enums'

function initFormBean() {
  const formBean = {
    remark: null,
    roleStatus: null,
    code: null,
    roleName: null,
    sysMenuList: []
  }
  return formBean
}

export default {
  name: 'SysRoleAdd',
  data() {
    return {
      enums: {
        commStatus: enums.getCommStatus()
      },
      treeData: [],
      checkedList: [],
      checkedListForm: [],
      defaultProps: {
        children: "children",
        label: "resName"
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        roleName: [ { required: true, message: '请输入角色名称', trigger: 'blur' }],
        code: [ { required: true, message: '请输入角色编码', trigger: 'blur' }]
      },
      windowHeight: 0
    }
  },
  created() {
    // this.getSysMenu()
     const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 300;
  },
  methods: {
    // getSysMenu() {
    //   sysMenuApi.fetchList({ pageNo: 1, pageSize: 1000 }).then(data => {
    //     this.treeData = data.data.list;
    //   })
    // },
    // 获取菜单
    async getMenu() {
      const { data } = await sysMenuApi.getRoleRouters(0);
      this.treeData = data;
    },
    // 获取菜单资源
    async getMenuResource(obj) {
      const { data } = await sysMenuApi.getRoleRouters(obj.id);
      this.treeData = data;
      let arr = this.treeData.filter(i => i.children.length);
      this.expandedList = arr.map(i => i.id);
      let arr1 = this.getCheckedIds(this.treeData, []);
      this.checkedList = arr1;
      this.checkedListForm = obj.sysMenuList
    },
    getCheckedIds(list) {
      let ids = [];
      list.forEach(item => {
        if (item.bindStatus && !item.children.length) ids.push(item.id);
        if (item.children.length) {
          ids = ids.concat(this.getCheckedIds(item.children, ids));
        }
      });
      return ids;
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.checkedList = []
      this.checkedListForm = []
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.getMenu()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.getMenuResource(row);
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    check(currentObj, treeStatus) {
      this.checkedListForm = [...treeStatus.checkedKeys, ...treeStatus.halfCheckedKeys];
      this.checkedList = treeStatus.checkedKeys
      // console.log('this.checkedList: ',this.checkedList);
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      if (this.checkedList.length == 0) {
        this.$message.error("请选择菜单资源");
        return;
      }
      this.form.sysMenuList = this.checkedListForm;
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.form.id > 0) {
            sysRoleApi.update(this.form).then((data) => {
              this.postCallback(data)
            });
          } else {
            sysRoleApi.create(this.form).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  padding-bottom: 40px;
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
</style>
